export type Price = {
  unit_amount: number | null
  tiers: Array<{ up_to: number | null; unit_amount: number; flat_amount: number }>
  tiers_mode: string | null
  currency: string
  discount_per_seat: number
  annual_discount_percent?: number
}

export function totalFor(price: Price, quantity: number, baseSeats: number): number {
  let cents = (price.unit_amount || 0) * quantity
  if (price.tiers.length) {
    cents = 0
    let previousLimit = 0
    for (const tier of price.tiers) {
      const limit = tier.up_to ?? Infinity
      if (price.tiers_mode === "volume") {
        if (quantity > limit) continue
        cents = tier.unit_amount * quantity + tier.flat_amount
        break
      }
      const units = Math.min(quantity, limit) - previousLimit
      if (units <= 0) break
      cents += tier.unit_amount * units + tier.flat_amount
      previousLimit = limit
    }
  }
  cents -= Math.round(Math.max(quantity - baseSeats, 0) * price.discount_per_seat * 100)
  cents -= Math.round(Math.max(cents, 0) * (price.annual_discount_percent || 0) / 100)
  return cents / 100
}
